import {
   SET_SELECTED_PATIENT,
   SET_PROVIDER_ABOUT_MODAL,
   SET_PROVIDER_MAIL,
   SET_NO_USER_FOUND,
   SET_PROFILE_IMAGE_UPDATE_FLAG,
   SET_IS_PROVIDER_PHOTO_AVAILABLE,
   SET_IS_PROFILE_COMPLETE,
   SET_PROFILE_IMAGE_UPDATE_FLAG_V2,
} from "../actions/profile.action";

const INITIAL_STATE = {
   selectedPatient: {
      list: null,
      loading: true,
   },
   showProviderAboutModal: false,
   callback: null,
   email: "",
   userNotFoundError: false,
   profileImageUpdateFlag: false,
   providerPhotoAvailable: false,
   isProfileComplete: true,
};

export default function patientProfile(state = INITIAL_STATE, action) {
   switch (action.type) {
      case SET_PROVIDER_MAIL:
         return {
            ...state,
            email: action.payload,
         };
      case SET_SELECTED_PATIENT:
         return {
            ...state,
            selectedPatient: action.payload,
         };
      case SET_PROVIDER_ABOUT_MODAL:
         return {
            ...state,
            showProviderAboutModal: !state.showProviderAboutModal,
            callback: action.payload,
         };
      case SET_NO_USER_FOUND:
         return {
            ...state,
            userNotFoundError: action.payload,
         };
      case SET_PROFILE_IMAGE_UPDATE_FLAG:
         return {
            ...state,
            profileImageUpdateFlag: true,
         };
      case SET_PROFILE_IMAGE_UPDATE_FLAG_V2:
         return {
            ...state,
            profileImageUpdateFlag: !state.profileImageUpdateFlag,
         };
      case SET_IS_PROVIDER_PHOTO_AVAILABLE:
         return {
            ...state,
            providerPhotoAvailable: action.payload,
         };
      case SET_IS_PROFILE_COMPLETE:
         return {
            ...state,
            isProfileComplete: action.payload,
         };
      default:
         return state;
   }
}
